import { deviceType } from "@tm/isomorphic-utils";
import { theme } from "@tm/utility/global";
import styled from "styled-components";

export const NudgeCardContent = styled.div`
  padding: 12px 20px;

  @media ${deviceType.mobile} {
    padding: 16px;
  }
`;

export const NudgeRow = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const NudgeIcon = styled.div`
  flex-shrink: 0;
  width: 38px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    display: block;
    width: 38px;
    height: 38px;
    object-fit: contain;
  }
`;

export const NudgeText = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 1px;
  min-width: 0;
`;

export const NudgeTitle = styled.p`
  margin: 0;
  font-family: Lato, sans-serif;
  font-size: 16px;
  font-weight: 900;
  line-height: normal;
  color: ${theme.blackText};
  word-break: break-word;
`;

export const NudgeDescription = styled.p`
  margin: 0;
  font-family: Lato, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: normal;
  color: ${theme.greyText};
  word-break: break-word;
`;

export const NudgeCtaButton = styled.button<{ disabled?: boolean }>`
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 143px;
  height: 32px;
  padding: 0 16px;
  border: 1px solid ${theme.blueText};
  border-radius: 8px;
  background: ${theme.whiteText};
  color: ${theme.blueText};
  font-family: Lato, sans-serif;
  font-size: 12px;
  font-weight: 900;
  line-height: normal;
  letter-spacing: 0;
  text-transform: uppercase;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  opacity: ${(props) => (props.disabled ? 0.45 : 1)};
  white-space: nowrap;

  &:focus-visible {
    outline: 2px solid ${theme.blueText};
    outline-offset: 2px;
  }

  @media ${deviceType.mobile} {
    display: none;
  }
`;

export const NudgeMobileIconCta = styled.button<{ disabled?: boolean }>`
  display: none;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0;
  border: none;
  background: transparent;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  opacity: ${(props) => (props.disabled ? 0.45 : 1)};

  img {
    display: block;
    width: 24px;
    height: 24px;
    object-fit: contain;
  }

  &:focus-visible {
    outline: 2px solid ${theme.blueText};
    outline-offset: 2px;
    border-radius: 4px;
  }

  @media ${deviceType.mobile} {
    display: inline-flex;
  }
`;
